import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 16,
    height: 16,
    color: 'inherit',
    flexShrink: 0,
  },
});

/**
 * Generated checklist review and approval icon.
 */
export const ChecklistApprovalIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M3 1.75H9.25L12 4.5V7.25"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M9 1.75V4.75H12"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M3 1.75V14.25H7"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M5.25 6.5H9.25"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinecap="round"
      />

      <path
        d="M5.25 9H7.25"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinecap="round"
      />

      <circle
        cx="10.25"
        cy="10.75"
        r="2.5"
        stroke="currentColor"
        strokeWidth="1.1"
      />

      <path
        d="M12.1 12.6L14.25 14.75"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinecap="round"
      />

      <path
        d="M9.15 10.75L9.9 11.5L11.4 10"
        stroke="currentColor"
        strokeWidth="1.0"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
